import { useState } from "react";
import FooterPolicy from "./FooterPolicy.js";
import { Link } from "react-router-dom";

export default function Footer() {
  const [showPolicy, setShowPolicy] = useState(false);

  return (
    <div className="w-full text-center p-4 border-t mt-10 text-sm relative">
      <div>
        {/* 🔗 New discoverable internal link (helps SEO via internal linking) */}
        <Link
          to="/turo-requirements-to-rent-your-car"
          className="text-sm text-blue-600 hover:underline"
        >
          Turo Requirements Guide
        </Link>
      </div>
      <button
        onClick={() => setShowPolicy(!showPolicy)}
        className="text-blue-600 underline"
      >
        Privacy Policy & Terms
      </button>

      {showPolicy && (
        <div className="absolute left-1/2 transform -translate-x-1/2 mt-4 w-[90vw] max-w-2xl bg-white shadow-lg border rounded p-6 z-50 text-left overflow-y-auto max-h-[80vh]">
          <button
            onClick={() => setShowPolicy(false)}
            className="absolute top-2 right-2 text-gray-500 hover:text-black text-lg"
          >
            ×
          </button>
          <FooterPolicy />
        </div>
      )}
    </div>
  );
}
